import React, { useState } from "react";
import { motion } from "framer-motion";

const Toggle = ({ children, title }) => {
  const [toggle, setToggele] = useState(false);
  return (
    <motion.div Layout className="question" onClick={() => setToggele(!toggle)}>
      {toggle ? children : ""}
      <motion.h4>{title}</motion.h4>
      <div className="faq-line"></div>
    </motion.div>
  );
};

export default Toggle;
